import AnimatedCharacter from "../../AnimatedCharacter";

export default class Guardian extends AnimatedCharacter {
    constructor(name, type, golden = false) {
        super(name);

        this._type = type;
        this._skinData = P3.assets.json("skin_slot_data");
        this._skinSlots = new Map();
        this._golden = golden;

        this._weaponRevealAnims = [];
    }

    init(skin) {
        super.init(skin);

        for (let i = 0; i < this._spine.skeleton.slots.length; ++i) {
            const slot = this._spine.skeleton.slots[i];

            for (let j = 0; j < this._skinData.length; ++j) {
                const t = this._skinData[j];
                if (slot.data.name === t.slot) {
                    this._mapSkinSlots(slot);
                }
            }
        }

        for (let i = 0; i < this._spine.spineData.defaultSkin.attachments.length; ++i) {
            const attachment = this._spine.spineData.defaultSkin.attachments[i];
            for (const j in attachment) this._mapSkinAttachments(attachment, j);
        }
    }

    setItem(name, type) {
        const index = type;
        const slot = this._skinSlots.get(name);
        slot.setAttachment(slot.attachmentGroup.get(slot.attachmentKey + index));
    }

    setSkin(name) {
        if (name) {
            if (this._golden)
                name = name + "_golden";
        }
        console.warn(name);
        super.setSkin(name);
    }

    setWeaponRevealAnims(arr) {
        this._weaponRevealAnims = arr.slice();
    }

    playWeaponRevealAnim() {
        if (!this._weaponRevealAnims.length) return;
        const name = P3.utils.selectRandom(this._weaponRevealAnims);
        this._spine.state.setAnimation(0, name, true);
    }

    onStateComplete(entry) {
        super.onStateComplete(entry);

        if (this._weaponRevealAnims.indexOf(entry.animation.name) !== -1) {
            this.playIdleAnim();
        }
    }

    onStateEvent(entry, event) {
        super.onStateEvent(entry, event);

        switch (event.stringValue) {
            case "weapon_reveal" : {
                this.setSkin(this._spine.skeleton.skin.name + "_golden");
                break;
            }
        }
    }

    _mapSkinSlots(slot) {
        for (const i in this._skinData) {
            if (this._skinData.hasOwnProperty(i)) {
                const t = this._skinData[i];
                if (slot.data.name === t.slot) {
                    this._skinSlots.set(t.slot, slot);
                    break;
                }
            }
        }
    }

    _mapSkinAttachments(attachment, key) {
        for (const i in this._skinData) {
            if (this._skinData.hasOwnProperty(i)) {
                const t = this._skinData[i];

                let slot = this._skinSlots.get(t.slot);
                if (!slot.attachmentGroup) {
                    slot.attachmentGroup = new Map();
                    slot.attachmentKey = t.attachmentPrefix;
                }

                for (let j = 1; j <= t.attachmentLength; j++) {
                    let k = t.attachmentPrefix + j;
                    k === key && slot.attachmentGroup.set(key, attachment[key]);
                }
            }
        }
    }

    get type() {
        return this._type;
    }
}

Guardian.TYPE_KNIGHT        = "knight";
Guardian.TYPE_KNIGHT_FEMALE = "knight_female";
Guardian.TYPE_WARRIOR       = "warrior";
Guardian.TYPE_WIZARD        = "wizard";
Guardian.TYPE_ELF           = "elf";
Guardian.TYPE_ELF_FEMALE    = "elf_female";
Guardian.TYPE_RANGER        = "ranger";
Guardian.TYPE_RANGER_FEMALE = "ranger_female";
Guardian.TYPE_WITCH         = "witch";